import React, { ReactElement, FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Typography } from 'antd'
import { s } from './style'

const { Title } = Typography

export const NoAcceptedProposal: FC = (): ReactElement => {
  const { t } = useTranslation()

  return (
    <div style={s.wrapper}>
      <div style={s.root}>
        <img width={230} src={require('../../../../Images/telephone.svg')} />
        <Title level={2} style={s.text}>
          {t(
            'eventHub.noAcceptedProposals.proposalsWithAm',
            'Your proposals are with your account manager - give them a call if you need the details'
          )}
        </Title>
      </div>
    </div>
  )
}
